/**
 * Makes radio button wrappers clickable.
 *
 * This improves usability by allowing users to click anywhere in the
 * radio button's wrapper element to select the radio button.
 */
export function initRadioWrapperClick(context, once) {
  console.log('initRadioWrapperClick');
  once(
    'radioWrapperClick',
    '.js-form-item.js-form-type-radio',
    context
  ).forEach(wrapper => {
    console.log('wrapper', wrapper);
    wrapper.addEventListener('click', event => {
      // Find the radio input within this wrapper
      const radioInput = wrapper.querySelector('input[type="radio"]');

      // Only proceed if we found an input and the click wasn't directly on the input
      // or on a label (which already triggers the input)
      if (
        radioInput &&
        event.target !== radioInput &&
        event.target.tagName !== 'LABEL'
      ) {
        // Prevent any default behavior
        event.preventDefault();
        // Trigger a click on the radio input
        radioInput.click();
      }
    });
  });
}
